import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Product from "./ProductItem";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { DateRangePicker } from "react-dates";
import config from "../config";
import Http from "axios";
import CSV from "react-csv-reader";
import InfiniteScroll from "./InfiniteScroll";
import { sortBy, debounce } from "lodash";

const _ = {
  sortBy,
  debounce
};

// import "react-dates/lib/css/_datepicker.css";

@inject("AdminStore")
@observer
class Admin extends Component {
  state = {
    category: {
      name: "",
      description: "",
      parent: ""
    },
    product: {
      name: "",
      imageFiles: [],
      description: "",
      category: "",
      qty: 1,
      pricePerDay: 0,
      specs: [],
      notes: [],
      includes: [],
      tags: [],
      waiver: [],
      activeTab: "specs"
    },
    order: {
      customUserName: "",
      startsAt: null,
      expiresAt: null,
      waiver: null,
      phone: "",
      address1: "",
      address2: "",
      product: null
    },
    usersQuery: "",
    specInput: "",
    tagsInput: "",
    focused: null,
    photoOpen: false,
    photoContent: {}
  };

  componentDidMount() {
    this.props.AdminStore.getMonthlyEarnings();
    this.props.AdminStore.getMonthlyRentals();
    this.props.AdminStore.getActiveRentals(true);
    this.props.AdminStore.getExpiredRentals(true);
    this.props.AdminStore.getActiveRentals();
    this.props.AdminStore.getExpiredRentals();
    this.props.AdminStore.getUsers();
    this.props.AdminStore.getCategories();
    this.props.AdminStore.getProducts();
  }

  togglePhotoCard = photoContent => {
    this.setState({
      photoOpen: !this.state.photoOpen,
      photoContent
    });
  };

  createCategory = () => {
    const { name, description, parent } = this.state.category;

    if (!name) {
      return;
    }

    Http.post(
      config.api + "/admin/categories/add",
      {
        name,
        description,
        parent
      },
      {
        withCredentials: true
      }
    )
      .then(category => {
        console.log(category);
        this.props.AdminStore.createCategory(category.data.result);
      })
      .catch(err => {
        console.error(err);
      });
  };

  addProduct = e => {
    e.preventDefault();
    const { name, description, qty } = this.state.product;

    if (!name || !description || !qty) {
      console.error();
      return;
    }

    Http.post(
      config.api + "/admin/products/add",
      {
        products: [this.state.product],
        type: "admin"
      },
      {
        withCredentials: true
      }
    )
      .then(product => {
        console.log(product);
        this.state.product.imageFiles
          ? Http.post(
              config.api + "/sign/product",
              {
                products: this.state.product.imageFiles.map(file => ({
                  objectName: file.name,
                  contentType: file.type,
                  productId: product.data.result[0]._id
                }))
              },
              {
                withCredentials: true
              }
            ).then(url => {
              const images = Promise.all(
                url.data.result.map((url, key) => {
                  const options = {
                    headers: {
                      "Content-Type": this.state.product.imageFiles[key].type
                    },
                    onUploadProgress: progress => {
                      console.log(progress);
                    }
                  };

                  console.log(this.state.product.imageFiles[key]);
                  toast.info("Product created, uploading product image...");

                  return Http.put(
                    url.signedUrl,
                    this.state.product.imageFiles[key],
                    options
                  );
                })
              );
              images
                .then(res => {
                  Http.post(
                    config.api + "/admin/products/pending",
                    {
                      id: product.data.result[0]._id
                    },
                    {
                      withCredentials: true
                    }
                  ).then(product => {
                    this.props.AdminStore.addProduct(product.data.result);
                    this.setState({
                      product: {
                        name: "",
                        imageFiles: [],
                        description: "",
                        category: "",
                        qty: 1,
                        pricePerDay: 0,
                        specs: [],
                        notes: [],
                        includes: [],
                        tags: [],
                        waiver: [],
                        activeTab: "specs"
                      }
                    });
                    toast.info("Uploaded product image successfully!");
                  });
                  console.log(res.data);
                })
                .catch(err => {
                  console.error(err, err.response.data);
                  toast.info("Product image upload failed!");
                });
            })
          : this.props.AdminStore.addProduct(product.data.result[0]);
      })
      .catch(err => {
        console.error(err);
        toast.info("Failed to create product");
      });
  };

  addExcelProducts = async products => {
    const addedProducts = await Http.post(
      config.api + "/admin/products/add",
      {
        products: products,
        type: "excel"
      },
      {
        withCredentials: true
      }
    );
    return addedProducts;
  };

  returnProduct = _id => {
    Http.post(
      config.api + "/admin/return",
      {
        _id
      },
      {
        withCredentials: true
      }
    ).then(returnedItem => {
      this.props.AdminStore.filterOrder(_id);
      toast.info("Returned product successfully");
    });
  };

  onDrop = file => {
    console.log(file[0]);
    this.setState({
      product: {
        ...this.state.product,
        imageFiles: [...this.state.product.imageFiles, file[0]]
      }
    });
  };

  createOrder = () => {
    Http.post(config.api + "/admin/orders/create", this.state.order, {
      withCredentials: true
    })
      .then(order => {
        console.log(order.data.result);
        this.setState({
          order: {
            customUserName: "",
            startsAt: null,
            expiresAt: null,
            waiver: null,
            phone: "",
            address1: "",
            address2: "",
            product: null
          }
        });
        toast.info("Created Local order");
      })
      .catch(err => {
        console.error(err);
      });
  };

  deleteCategory = categoryId => {
    this.props.AdminStore.deleteCategory(categoryId);
    this.setState({
      category: {
        ...this.state.category,
        parent: ""
      }
    });
  };

  handleCSV = async file => {
    try {
      const csv = file.slice(1);
      console.log(csv);
      const products = csv
        .filter(
          product =>
            product.length === 14 &&
            product[0] &&
            product[2] &&
            product[3] &&
            product[7] &&
            product[11] &&
            product[10]
        )
        .map(product => {
          console.log(product);
          return {
            name: product[0],
            description: product[1],
            price: parseFloat(product[2]),
            pricePerDay: parseFloat(product[3]),
            specs: product[4] ? product[4].split(";") : [],
            includes: product[5] ? product[5].split(";") : [],
            notes: product[6] ? product[6].split(";") : [],
            company: product[7],
            tags: product[8] ? product[8].split(";") : [],
            qty: parseInt(product[9], 10),
            category: product[10],
            images: product[11].split(";"),
            downloadable: product[12].toLowerCase().trim(),
            downloadableFilename: product[13].trim()
          };
        });
      console.log(products);
      toast.info("Creating products from CSV");
      const addedProducts = await this.addExcelProducts(products);
      this.props.AdminStore.setProducts(addedProducts.data.result);
      toast.info("Products successfully added");
    } catch (err) {
      console.error(err);
      toast.error("Failed to add products");
    }
  };

  searchUsers = () =>
    this.props.AdminStore.users.filter(
      user =>
        user.email.indexOf(this.state.usersQuery) > -1 ||
        user.username.indexOf(this.state.usersQuery) > -1
    );

  searchProducts = _.debounce(async query => {
    const products = await (query
      ? Http.post(
          `${config.api}/admin/products/search`,
          { name: query },
          {
            withCredentials: true
          }
        )
      : { data: { result: [] } });
    this.props.AdminStore.setSearchProducts(products.data.result, query);
  }, 1500);

  getProducts() {
    return this.props.AdminStore.searching
      ? this.props.AdminStore.searchedProducts
      : this.props.AdminStore.products.docs;
  }

  render() {
    const selectedProduct = this.props.AdminStore.products.docs.reduce(
      (selectedProduct, product) =>
        product._id === this.state.order.product ? product : selectedProduct,
      {
        waiver: []
      }
    );

    const selectedWaiver = waiverName =>
      selectedProduct.waiver.filter(waiver => waiver.name === waiverName)[0];

    return (
      <div className="main-content">
        <div
          className={"photo-id-modal" + (this.state.photoOpen ? " active" : "")}
        >
          <div className="modal-overlay" onClick={this.togglePhotoCard} />
          <div className="photo-id-container">
            <div className="back-photo">
              <div className="title">Back Photo</div>
              <img
                src={this.state.photoContent.back}
                alt=""
                className="card-image"
              />
            </div>
            <div className="front-photo">
              <div className="title">Front Photo</div>
              <img
                src={this.state.photoContent.front}
                alt=""
                className="card-image"
              />
            </div>
          </div>
        </div>
        <div className="section-title standalone">
          <p>ADMINSTRATION PANEL</p>
          <div className="sep" />
        </div>

        <div className="admin-title">
          <p>MONTHLY STATS</p>
        </div>
        <div className="admin-stats">
          <div className="box">
            <span>
              ${this.props.AdminStore.statistics.monthlyEarnings.toFixed(2)}
            </span>
            <p>Monthly rent earnings</p>
          </div>
          <div className="box">
            <span>{this.props.AdminStore.statistics.monthlyRentals}</span>
            <p>Items rented this month</p>
          </div>
          <div className="box">
            <span>{this.props.AdminStore.statistics.activeRentals}</span>
            <p>Items still rented</p>
          </div>
          <div className="box">
            <span>{this.props.AdminStore.statistics.expiredRentals}</span>
            <p>Items Should be returned</p>
          </div>
        </div>

        <div className="admin-title title-no-margin">
          <p>CHECK MEMBERS INFO</p>
          <input
            type="text"
            placeholder="Search for user"
            onChange={e =>
              this.setState({
                usersQuery: e.target.value
              })
            }
          />
        </div>
        <div className="in-shop-list">
          {(this.state.usersQuery
            ? this.searchUsers()
            : this.props.AdminStore.users
          ).map(user => (
            <div className="entry" key={user.username}>
              <Link to={`/admin/account/${user._id}`} className="name">
                {user.username}
              </Link>
              <p>Rented: {user.totalRented}</p>
              <p>Currently Renting: {user.activeRentals}</p>
              <button
                className="returned"
                onClick={() => this.togglePhotoCard(user.identity)}
              >
                View Photo ID
              </button>
              <div className="address-block">
                {user.addresses ? (
                  <div className="address1">
                    Address 1: {user.addresses.address1}
                  </div>
                ) : null}
                {user.addresses ? (
                  <div className="address2">
                    Address 2: {user.addresses.address2}
                  </div>
                ) : null}
                {user.phone ? (
                  <div className="phone">Phone: {user.phone}</div>
                ) : null}
                <div className="email">Email: {user.email}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="admin-title title-no-margin">
          <p>CREATE CATEGORY</p>
        </div>
        <div className="create-cate-container">
          <div className="create-cate">
            <label htmlFor="create">New Category Name</label>
            <input
              type="text"
              name="create"
              onChange={e =>
                this.setState({
                  category: {
                    ...this.state.category,
                    name: e.target.value
                  }
                })
              }
            />
            <label htmlFor="parent">Parent Category</label>
            <select
              name="parent"
              onChange={e =>
                this.setState({
                  category: {
                    ...this.state.category,
                    parent: e.target.value
                  }
                })
              }
            >
              <option value="">None</option>
              {this.props.AdminStore.categories.map(category => (
                <option value={category._id} key={category._id}>
                  {category.name}
                </option>
              ))}
            </select>
            <button onClick={this.createCategory}>CREATE CATEGORY</button>
          </div>
          <div className="create-cate-preview">
            {this.props.AdminStore.categories.map(category => (
              <div
                className="create-cate-category"
                style={{ marginLeft: 50 * (category.level - 1) }}
                key={category._id}
              >
                <p>{category.name}</p>
                <div className="remove-btn">
                  <i
                    className="fa fa-remove"
                    onClick={() => this.deleteCategory(category._id)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="admin-title">
          <p>ADD NEW ITEMS</p>
        </div>
        <div className="cms-holder">
          <div className="pic-uploader">
            <div className="itemthumb">
              <Dropzone
                onDrop={this.onDrop}
                accept="image/*"
                multiple={false}
                style={{
                  height: 392,
                  width: 450
                }}
              >
                {this.state.product.imageFiles.length > 0 ? (
                  <div
                    className="itempic"
                    style={{
                      backgroundImage: `url(${
                        this.state.product.imageFiles[0]
                          ? this.state.product.imageFiles[0].preview
                          : null
                      })`
                    }}
                  />
                ) : (
                  <div className="itempic">
                    <i className="fa fa-plus" />
                  </div>
                )}
                <div className="uploadbtn">
                  <p>UPLOAD ITEM IMAGE</p>
                </div>
              </Dropzone>
              <div
                className="product-images-container"
                style={{ marginTop: 15 }}
              >
                {this.state.product.imageFiles.map((image, key) => (
                  <div
                    className="admin-product-image"
                    style={{
                      backgroundImage: `url(${image.preview})`,
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      width: 100,
                      height: 100,
                      borderRadius: 7,
                      marginRight: 25,
                      marginBottom: 15
                    }}
                    onClick={() =>
                      this.setState({
                        product: {
                          ...this.state.product,
                          imageFiles: this.state.product.imageFiles.filter(
                            (image, imageKey) => imageKey !== key
                          )
                        }
                      })
                    }
                  >
                    <i className="delete-btn fa fa-times" />
                  </div>
                ))}
              </div>
              <CSV
                cssClass="csv-btn"
                label="Add Products via CSV file"
                onFileLoaded={this.handleCSV}
                onError={this.handleCSVError}
              />
            </div>
            <div className="prim-details">
              <div className="product-name">
                <label htmlFor="productname">Product name</label>
                <input
                  type="text"
                  name="productname"
                  placeholder="Input product name here..."
                  onChange={e =>
                    this.setState({
                      product: {
                        ...this.state.product,
                        name: e.target.value
                      }
                    })
                  }
                  value={this.state.product.name}
                />
                <div className="form-group">
                  <div
                    className="form-third"
                    style={{
                      width: "64%"
                    }}
                  >
                    <label htmlFor="qty">Company</label>
                    <input
                      type="text"
                      name="productname"
                      placeholder="Product Company..."
                      onChange={e =>
                        this.setState({
                          product: {
                            ...this.state.product,
                            company: e.target.value
                          }
                        })
                      }
                      value={this.state.product.company}
                    />
                  </div>
                  <div className="form-third">
                    <label htmlFor="qty">Item Quantity in Stock</label>
                    <input
                      type="number"
                      name="qty"
                      min="1"
                      value={this.state.product.qty}
                      onChange={e =>
                        this.setState({
                          product: {
                            ...this.state.product,
                            qty: e.target.value
                          }
                        })
                      }
                    />
                  </div>
                  <div className="form-third">
                    <label htmlFor="qty">Price Per Day</label>
                    <input
                      type="number"
                      name="price"
                      min="1"
                      value={this.state.product.pricePerDay}
                      onChange={e =>
                        this.setState({
                          product: {
                            ...this.state.product,
                            pricePerDay: e.target.value
                          }
                        })
                      }
                    />
                  </div>
                </div>
                <label htmlFor="cate">Category</label>
                <select
                  name="cate"
                  onChange={e =>
                    this.setState({
                      product: {
                        ...this.state.product,
                        category: e.target.value
                      }
                    })
                  }
                  required
                >
                  <option disabled selected value={false}>
                    Please select a Category
                  </option>
                  <option disabled value={false}>
                    ---------
                  </option>
                  {this.props.AdminStore.categories.map(category => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                <label htmlFor="desc">Description</label>
                <textarea
                  name="desc"
                  value={this.state.product.description}
                  onChange={e =>
                    this.setState({
                      product: {
                        ...this.state.product,
                        description: e.target.value
                      }
                    })
                  }
                />
              </div>
              <div className="specs-lister">
                <div className="list-tabs">
                  <div
                    className={[
                      "tab",
                      this.state.product.activeTab === "specs"
                        ? "active-tab"
                        : ""
                    ].join(" ")}
                    onClick={() =>
                      this.setState({
                        product: {
                          ...this.state.product,
                          activeTab: "specs"
                        }
                      })
                    }
                  >
                    Add Specs
                  </div>
                  <div
                    className={[
                      "tab",
                      this.state.product.activeTab === "notes"
                        ? "active-tab"
                        : ""
                    ].join(" ")}
                    onClick={() =>
                      this.setState({
                        product: {
                          ...this.state.product,
                          activeTab: "notes"
                        }
                      })
                    }
                  >
                    Add Notes
                  </div>
                  <div
                    className={[
                      "tab",
                      this.state.product.activeTab === "includes"
                        ? "active-tab"
                        : ""
                    ].join(" ")}
                    onClick={() =>
                      this.setState({
                        product: {
                          ...this.state.product,
                          activeTab: "includes"
                        }
                      })
                    }
                  >
                    Add Includes
                  </div>
                  <div
                    className={[
                      "tab",
                      this.state.product.activeTab === "tags"
                        ? "active-tab"
                        : ""
                    ].join(" ")}
                    onClick={() =>
                      this.setState({
                        product: {
                          ...this.state.product,
                          activeTab: "tags"
                        }
                      })
                    }
                  >
                    Add Tags
                  </div>
                  <div
                    className={[
                      "tab",
                      this.state.product.activeTab === "waivers"
                        ? "active-tab"
                        : ""
                    ].join(" ")}
                    onClick={() =>
                      this.setState({
                        product: {
                          ...this.state.product,
                          activeTab: "waivers"
                        }
                      })
                    }
                  >
                    Add Waivers
                  </div>
                </div>
                <div className="specs-list">
                  {this.state.product.activeTab === "specs"
                    ? this.state.product.specs.map((spec, key) => (
                        <div className="entry" key={key}>
                          {spec}
                        </div>
                      ))
                    : this.state.product.activeTab === "includes"
                    ? this.state.product.includes.map((include, key) => (
                        <div className="entry" key={key}>
                          {include}
                        </div>
                      ))
                    : this.state.product.activeTab === "notes"
                    ? this.state.product.notes.map((note, key) => (
                        <div className="entry" key={key}>
                          {note}
                        </div>
                      ))
                    : this.state.product.activeTab === "tags"
                    ? this.state.product.tags.map((tag, key) => (
                        <div className="entry" key={key}>
                          {tag}
                        </div>
                      ))
                    : this.state.product.waiver}
                </div>
                <div className="spec-adder">
                  <input
                    type="text"
                    placeholder="Spec name"
                    value={
                      this.state.product.activeTab === "specs"
                        ? this.state.specInput
                        : this.state.product.activeTab === "notes"
                        ? this.state.notesInput
                        : this.state.product.activeTab === "includes"
                        ? this.state.includesInput
                        : this.state.product.activeTab === "tags"
                        ? this.state.tagsInput
                        : null
                    }
                    onChange={e =>
                      this.setState(
                        this.state.product.activeTab === "specs"
                          ? {
                              specInput: e.target.value
                            }
                          : this.state.product.activeTab === "notes"
                          ? {
                              notesInput: e.target.value
                            }
                          : this.state.product.activeTab === "includes"
                          ? {
                              includesInput: e.target.value
                            }
                          : this.state.product.activeTab === "tags"
                          ? {
                              tagsInput: e.target.value
                            }
                          : null
                      )
                    }
                  />
                  <button
                    onClick={() =>
                      this.setState(
                        this.state.product.activeTab === "specs"
                          ? {
                              product: {
                                ...this.state.product,
                                specs: [
                                  ...this.state.product.specs,
                                  this.state.specInput
                                ]
                              },
                              specInput: ""
                            }
                          : this.state.product.activeTab === "includes"
                          ? {
                              product: {
                                ...this.state.product,
                                includes: [
                                  ...this.state.product.includes,
                                  this.state.includesInput
                                ]
                              },
                              includesInput: ""
                            }
                          : this.state.product.activeTab === "notes"
                          ? {
                              product: {
                                ...this.state.product,
                                notes: [
                                  ...this.state.product.notes,
                                  this.state.notesInput
                                ]
                              },
                              notesInput: ""
                            }
                          : this.state.product.activeTab === "tags"
                          ? {
                              product: {
                                ...this.state.product,
                                tags: [
                                  ...this.state.product.tags,
                                  this.state.tagsInput
                                ]
                              },
                              tagsInput: ""
                            }
                          : {}
                      )
                    }
                  >
                    Add Spec to list
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="extra-details" />
          <button class="additem" onClick={this.addProduct}>
            ADD ITEM TO SHOP
          </button>
        </div>

        <div className="admin-title">
          <p>CREATE STORE ORDER</p>
        </div>
        <div className="cms-holder">
          <div className="pic-uploader">
            <div
              className="prim-details"
              style={{
                width: "100%"
              }}
            >
              <div className="product-name">
                <label htmlFor="productname">Client name</label>
                <input
                  type="text"
                  name="productname"
                  placeholder="Input product name here..."
                  onChange={e =>
                    this.setState({
                      order: {
                        ...this.state.order,
                        customUserName: e.target.value
                      }
                    })
                  }
                  value={this.state.order.customUserName}
                />
                <div className="form-group">
                  <div
                    className="form-third"
                    style={{
                      width: "33.3333%"
                    }}
                  >
                    <label htmlFor="qty">Product</label>
                    <select
                      name="productname"
                      placeholder="Product..."
                      onChange={e => {
                        this.setState({
                          order: {
                            ...this.state.order,
                            product: e.target.value,
                            waiver: ""
                          }
                        });
                      }}
                    >
                      <option selected disabled>
                        Please select a product
                      </option>
                      <option disabled>---------</option>
                      {this.props.AdminStore.products.docs.map(product => (
                        <option key={product._id} value={product._id}>
                          {product.name} ($
                          {product.pricePerDay.toFixed(2)}
                          /day)
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className="form-third"
                    style={{
                      width: "33.3333%"
                    }}
                  >
                    <label htmlFor="qty">Waiver</label>
                    <select
                      name="productwaiver"
                      onChange={e => {
                        this.setState({
                          order: {
                            ...this.state.order,
                            waiver: {
                              name: selectedWaiver(e.target.value).name,
                              price: selectedWaiver(
                                e.target.value
                              ).price.toFixed(2)
                            }
                          }
                        });
                      }}
                      disabled={!selectedProduct.waiver}
                      value={
                        this.state.order.waiver
                          ? this.state.order.waiver.name
                          : false
                      }
                    >
                      <option value={false}>N/A</option>
                      {selectedProduct.waiver
                        ? selectedProduct.waiver.map(waiver => (
                            <option
                              key={waiver.name + ": " + waiver.price}
                              value={waiver.name}
                            >
                              {waiver.name}: ${waiver.price.toFixed(2)}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>
                  <div className="form-third">
                    <label htmlFor="qty">Starts At</label>
                    <div className="admin-date">
                      <DateRangePicker
                        startDate={this.state.order.startsAt} // momentPropTypes.momentObj or null,
                        endDate={this.state.order.expiresAt} // momentPropTypes.momentObj or null,
                        onDatesChange={({ startDate, endDate }) =>
                          this.setState({
                            order: {
                              ...this.state.order,
                              startsAt: startDate,
                              expiresAt: endDate
                            }
                          })
                        } // PropTypes.func.isRequired,
                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={focusedInput =>
                          this.setState({ focusedInput })
                        } // PropTypes.func.isRequired,
                        numberOfMonths={1}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-third">
                    <label htmlFor="desc">Address 1</label>
                    <input
                      name="address1"
                      onChange={e =>
                        this.setState({
                          order: {
                            ...this.state.order,
                            address1: e.target.value
                          }
                        })
                      }
                      value={this.state.order.address1}
                    />
                  </div>
                  <div className="form-third">
                    <label htmlFor="desc">Address 2</label>
                    <input
                      name="address2"
                      onChange={e =>
                        this.setState({
                          order: {
                            ...this.state.order,
                            address2: e.target.value
                          }
                        })
                      }
                      value={this.state.order.address2}
                    />
                  </div>
                  <div className="form-third">
                    <label htmlFor="desc">Phone</label>
                    <input
                      name="phone"
                      onChange={e =>
                        this.setState({
                          order: {
                            ...this.state.order,
                            phone: e.target.value
                          }
                        })
                      }
                      value={this.state.order.phone}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button class="additem" onClick={this.createOrder}>
            ADD ORDER
          </button>
        </div>

        <div className="admin-title title-no-margin">
          <p>ITEMS IN SHOP</p>
          <input
            type="text"
            placeholder="Search"
            onChange={e => this.searchProducts(e.target.value)}
          />
        </div>
        <div
          className="shop-container in-shop-list"
          style={{
            width: "100%"
          }}
          ref="shopContainer"
        >
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            loadMore={() => this.props.AdminStore.setProductsPage()}
            hasMore={
              this.props.AdminStore.page < this.props.AdminStore.products.pages
            }
            scrollParent={this.refs.shopContainer}
            useWindow={false}
            useCapture={true}
            threshold={100}
          >
            {this.getProducts().map(product => (
              <Product
                editMode={true}
                key={product._id}
                product={product}
                id={product._id}
                name={product.name}
                qty={product.qty}
                price={product.pricePerDay.toFixed(2)}
                image={product.images.length > 0 ? product.images[0] : null}
              />
            ))}
          </InfiniteScroll>
        </div>

        <div className="admin-title title-no-margin">
          <p>RENTED ITEMS</p>
          <input type="text" placeholder="Search" />
        </div>
        <div className="in-shop-list">
          {this.props.AdminStore.expiredRentals.map(rental => (
            <div className="entry late" key={rental._id}>
              <p className="name">{rental.products.length} Products</p>
              <p>
                Renter:{" "}
                {rental._user
                  ? [rental._user.firstName, rental._user.lastName].join(" ")
                  : rental.customUserName}
              </p>
              <p>${rental.value}</p>
              <p>Rented on {rental.created_at}</p>
              <p>Expired on {rental.expiresAt}</p>
              <button
                className="returned"
                onClick={() => this.returnProduct(rental._id)}
              >
                Mark as Returned
              </button>
              <div className="address-block">
                {rental.pickedUp
                  ? [
                      <div
                        className="pickedup"
                        key={rental._id + rental.address1}
                      >
                        Pickup @ {rental.address1} {rental.address2}
                      </div>,
                      <div className="phone" key={rental._id + rental.phone}>
                        Phone: {rental.phone}
                      </div>,
                      rental._user ? (
                        <div
                          className="email"
                          key={rental._id + rental._user.email}
                        >
                          Email: {rental._user.email}
                        </div>
                      ) : null
                    ]
                  : [
                      <div
                        className="address1"
                        key={rental._id + rental.address1 + "1"}
                      >
                        Address 1: {rental.address1}
                      </div>,
                      <div
                        className="address2"
                        key={rental._id + rental.address2 + "2"}
                      >
                        Address 2: {rental.address2}
                      </div>,
                      <div className="phone" key={rental._id + rental.phone}>
                        Phone: {rental.phone}
                      </div>,
                      rental._user ? (
                        <div
                          className="email"
                          key={rental._id + rental._user.email}
                        >
                          Email: {rental._user.email}
                        </div>
                      ) : null
                    ]}
              </div>
            </div>
          ))}
          {this.props.AdminStore.activeRentals.map((rental, key) => {
            return (
              <div className="entry" key={rental._id}>
                <p className="name">{rental.products.length} Products</p>
                <p>
                  Renter:{" "}
                  {rental._user
                    ? [rental._user.firstName, rental._user.lastName].join(" ")
                    : rental.customUserName}
                </p>
                <p>${rental.value.toFixed(2)}</p>
                <p>
                  {rental.rentalStarted ? "Rented on" : "Will Rent On"}{" "}
                  {rental.created_at}
                </p>
                <p>Expires on {rental.expiresAt}</p>
                <button
                  className="returned"
                  onClick={() => this.returnProduct(rental._id)}
                >
                  Mark as Returned
                </button>
                <div className="address-block">
                  {rental.pickedUp
                    ? [
                        <div
                          className="pickedup"
                          key={rental._id + rental.address1}
                        >
                          Pickup @ {rental.address1} {rental.address2}
                        </div>,
                        <div className="phone" key={rental._id + rental.phone}>
                          Phone: {rental.phone}
                        </div>,
                        rental._user ? (
                          <div
                            className="email"
                            key={rental._id + rental._user.email}
                          >
                            Email: {rental._user.email}
                          </div>
                        ) : null
                      ]
                    : [
                        <div
                          className="address1"
                          key={rental._id + rental.address1 + "1"}
                        >
                          Address 1: {rental.address1}
                        </div>,
                        <div
                          className="address2"
                          key={rental._id + rental.address2 + "2"}
                        >
                          Address 2: {rental.address2}
                        </div>,
                        <div className="phone" key={rental._id + rental.phone}>
                          Phone: {rental.phone}
                        </div>,
                        rental._user ? (
                          <div
                            className="email"
                            key={rental._id + rental._user.email}
                          >
                            Email: {rental._user.email}
                          </div>
                        ) : null
                      ]}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/components/Admin.js